import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/audits',
  title: 'Auditoria',
  endpoint: '/app/audit',
  breadcrumbs: [],
}
